import React, { useEffect, useState } from "react";
import DateCell from "../datecell/datecell";
import { Navigate, useNavigate } from "react-router-dom";
import { ButtonGroup, Modal, Button, Dropdown } from 'react-bootstrap';
import AltDateCell from "../altdatecell/altdatecell";
import {capitalize, toggleSubscribe, editUser} from "../../utils/utils";
import { ReactComponent as KiwiIcon } from '../../icons/kiwi.svg';
import { ReactComponent as KangarooIcon } from '../../icons/kangaroo.svg';
import * as utils from '../../utils/utils';
import useGlobal from "../../store";
import "./userrow.scss";

const UserRow = (props) => {
    const [globalState, globalActions] = useGlobal();
    const navigate = useNavigate();
    const [location, setLocation] = useState(props.user.employee.location);
    const [subscribed, setSubscribed] = useState(false);
    const [showDropDown, setShowDropDown] = useState(props.user.username === globalState.login.username);
    const [locationIcons, setLocationIcons] = useState({});
    const [errors, setErrors] = useState({});

    useEffect(() => {

        setLocationIcons({
            'nz': <KiwiIcon style={{ width: 30, height: 30 }} />,
            'aus': <KangarooIcon style={{ width: 30, height: 30 }} />
        });

        // check if logged user's subscriptions contain this user
        globalState.users.map((user, idx) => {
            // if it's currently logged user
            if (user.username === globalState.login.username) {
                // loop through subscriptions and if any is for the username from props, it's subscribed
                user.employee.subscriptions.map((sub, idx) => {
                    if (sub.subscribed_to_name === props.user.username) {
                        setSubscribed(true);
                    }
                })
            }
        });
    }, [subscribed]);

    if (!props.user.employee) {
        return null;
    }

    const handleSubscribe = () => {
        const subscribe_to = props.user.username;
        const subscribe_by = globalState.login.username;
        const startDate = new Date(Math.min(...props.dates));
        const endDate = new Date(Math.max(...props.dates));

        toggleSubscribe(
            globalState.login.token, 
            startDate.toLocaleDateString('fr-CA'), 
            endDate.toLocaleDateString('fr-CA'), 
            subscribe_to,subscribe_by,
            globalActions.setPresences,
            setSubscribed
        );
    }

    const LocationButton = () => {
        if (props.user.employee.restricted_to_location) {
            return null;
        }

        if (showDropDown) {
            return (
                <Dropdown onSelect={handleModalChange}>
                    <Dropdown.Toggle
                        as="span"
                        className="locationIcon clickable"
                    >
                        {locationIcons[location]}
                    </Dropdown.Toggle>

                    <Dropdown.Menu>
                        <Dropdown.Item eventKey="nz">NZ</Dropdown.Item>
                        <Dropdown.Item eventKey="aus">AUS</Dropdown.Item>
                    </Dropdown.Menu>
                </Dropdown>
            );
        }

        return (
            <span className="locationIcon">
                {locationIcons[location]}
            </span>
        );
    };


    const SubscribeButton = () => {
        if (!props.user.employee.restricted_to_location) {
            return null;
        }
        
        if (subscribed) {
            return(
                <a  href=""
                    className="btn-group"
                    onClick={(e) => {
                        e.preventDefault();
                        handleSubscribe(e);
                    }}
                >
                    <i className="bi bi-binoculars-fill" style={{ fontSize: 20 }}></i>
                    <span className="tooltip-text">Unsubscribe from changes</span>
                </a>
            )
        }
        return(
            <a  href=""
                className="btn-group"
                onClick={(e) => {
                    e.preventDefault();
                    handleSubscribe(e);
                }}
            >
                <i className="bi bi-binoculars" style={{ fontSize: 20 }}></i>
                <span className="tooltip-text">Subscribe to changes</span>
            </a>
        )
    }

    const CustomToggle = React.forwardRef(({ onClick }, ref) => (
        <a
            href=""
            ref={ref}
            onClick={(e) => {
                e.preventDefault();
                onClick(e);
            }}
            className="btn-group location-toggle"
            aria-label="Change location"
        />
    ));

    const handleModalChange = (loc) => {
        const form = {
            'username': props.user.username,
            'password': null,
            'firstname': '',
            'lastname': '',
            'location': loc.toUpperCase(),
            'dept': props.user.employee.dept,
            'email': null,
            'work_schedules': props.user.work_schedules
        }
        setLocation(loc);
        editUser(globalState.login.token, form['username'], form['password'], globalState.is_staff, form['firstname'], form['lastname'], form['email'], form['location'], form['dept'], form['work_schedules'], navigate, globalActions.setCreds, setErrors);
    };


    return (
        <div className="row wrapper">
            <div className="flex-row cell first user-cell" role="cell" key={props.user.username}>

                {/* <span className="user-location">
                    <LocationButton />
                </span> */}

                <span className="username">
                    {capitalize(props.user.username)}
                </span>

                <span className="user-actions">
                    <SubscribeButton />
                </span>

            </div>
            
            {props.dates.map((date, idx) => (
                <AltDateCell 
                    date={date}
                    presences={props.user.presences}
                    work_schedules={props.user.work_schedules}
                    username={props.user.username}
                    is_staff={globalState.login.is_staff}
                    birthday={props.user.employee.birthday}
                    anniv_date={props.user.employee.anniv_date}
                    company_start={props.user.employee.company_start}
                    key={`datecell_${idx}`}
                    showAlert={props.showAlert}
                />
            ))}
        </div>
    )
}

export default UserRow;